/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface EvidenceSerialiser
 */
export interface EvidenceSerialiser {
  /**
   *
   * @type {number}
   * @memberof EvidenceSerialiser
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof EvidenceSerialiser
   */
  title: string;
  /**
   *
   * @type {Array<number>}
   * @memberof EvidenceSerialiser
   */
  artefacts?: Array<number>;
  /**
   *
   * @type {string}
   * @memberof EvidenceSerialiser
   */
  description?: string | null;
}

/**
 * Check if a given object implements the EvidenceSerialiser interface.
 */
export function instanceOfEvidenceSerialiser(value: object): value is EvidenceSerialiser {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('title' in value) || value['title'] === undefined) return false;
  return true;
}

export function EvidenceSerialiserFromJSON(json: any): EvidenceSerialiser {
  return EvidenceSerialiserFromJSONTyped(json, false);
}

export function EvidenceSerialiserFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceSerialiser {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    title: json['title'],
    artefacts: json['artefacts'] == null ? undefined : json['artefacts'],
    description: json['description'] == null ? undefined : json['description'],
  };
}

export function EvidenceSerialiserToJSON(value?: Omit<EvidenceSerialiser, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    title: value['title'],
    artefacts: value['artefacts'],
    description: value['description'],
  };
}
